
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 8.11V7.89c6.246 0 6.89-.644 6.89-6.889h.221c0 6.245.644 6.889 6.889 6.889v.222c-6.245 0-6.889.644-6.889 6.889H7.89c0-6.245-.643-6.89-6.889-6.89","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    